import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { fetchAllPlans } from "./action";

export const planEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.planName,
});

const initialState = planEntityAdapter.getInitialState({
  loading: false,
  error: null,
  planListing: [],
});

export const planSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPlans.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status) {
          planEntityAdapter.setAll(state, action.payload.data);
          state.planListing = action.payload.data;
        } else {
          state.error = action.payload.message || "Unexpected error occurred";
        }
      })
      .addCase(fetchAllPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch plans";
      });
  },
});

export default planSlice.reducer;
